module.exports = __webpack_public_path__ + "d815037bc27cc3294456ca4b7f041018.svg";